<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Quản lý người dùng</div>
      </div>
      <div class="card card-w-title">
        <div class="list-data">
          <div class="p-grid">
            <div class="p-col-6" v-if="$myConstants.checkRoleGroup('users', 'download')">
              <div class="import-data-custom download-data-custom">
                <button class="download-file-custom" @click="exportDataExcel" >
                  <i class="pi pi-download"></i>Xuất dữ liệu
                </button>
                <span >(Danh sách đơn vị được tải về theo điều kiện lọc đã nhập)</span>
              </div>
            </div>
            <div class="p-col-6">
              <div :class="'box-info-account '+($myConstants.checkRoleGroup('users', 'download') == true ? 'text-right':'text-left') " v-if="showTextInfo">
                <span v-html="textInfoAcccount"></span>
              </div>
            </div>
          </div>
          <div class="list-title">
            <span class="p-m-0">Danh sách tài khoản người dùng</span>
            <span class="p-input-icon-left" v-if="checkVisible('users', 'add')">
              <Button
              :label="'Tạo mới'"
                type="button"
                v-on:click="onActionClicked({action: {name: 'add', label: 'Tạo mới', path: `admin/users/add`}, key: 'add'})"
              > </Button>
            </span>
          </div>
          <BaseCommon v-if="dataModel"
            :key="componentKey"
            :listData="listData"
            :model="dataModel"
            :filterDefault="filters"
            @filter="filterData"
            :actions="getRowActions()"
            v-on:action-click="onActionClicked"
            @clearFilter="cancelFilter"
          ></BaseCommon>
        </div>
      </div>
    </div>
    <Dialog
        class="dialog-comfirm-common"
        :visible.sync="showConfirmDialog"
        :contentStyle="{overflow: 'visible'}"
        :modal="true"
        :closable="true"
    >
      <div class="box_body_popup" >
        <div v-if="creenConfirmDialog == 'export_success'">
          <div class="box_title_suceess"><img class="img_noti" :src="check_success_img" /><span class="title_noti" style="">Thành công</span></div>
          <p class="p_title_1" style="text-align: left"><span style="font-weight: 700">Danh sách tài khoản người dùng</span> đã xuất dữ liệu thành công. Vui lòng thực hiện tải về tại module Lịch sử xuất dữ liệu.</p>
          <div class="box_btn">
            <Button
                icon="pi pi-chevron-circle-right"
                iconPos="right"
                class="btn-custom"
                :label="'Lịch sử xuất dữ liệu'"
                type="button"
                @click="redirect_ToHistory"
            > </Button>
          </div>
        </div>
        <div v-if="creenConfirmDialog == 'export_err'">
          <div class="box_title_err"><img class="img_noti" :src="err_massage_img" /><span class="title_noti" style="">Thất bại</span></div>
          <p class="p_title_1" style="text-align: left">Quá trình xuất dữ liệu <span style="font-weight: 700;">Danh sách tài khoản người dùng</span> đã xảy ra vấn đề. Bạn vui lòng thực hiện lại thao tác xuất dữ liệu.</p>
        </div>
      </div>
      <template #header>
        <div>
          <span class="title-confirm" >Thông báo</span>
          <!--<span class="description-confirm">asdasdas</span>-->
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import BaseCommon from '../common'
import moment from "moment";
export default {
  components: {
    BaseCommon
  },
  data() {
    return {
      filters: {},
      listData: [],
      dataModel: null,
      componentKey: 0,
      seconds: 7,
      textInfoAcccount: 'Số tài khoản đang hoạt động của đơn vị bạn: {0}',
      organizationID: 0,
      showTextInfo: false,
      listDataExport:[],
      creenConfirmDialog:'export_success',
      check_success_img: window.origin + '/assets/images/check_success.png',
      err_massage_img: window.origin + '/assets/images/err_massage.png',
      showConfirmDialog:false,
      userID : null,
    }
  },
  mounted () {
    this.initData();
    if(this.$store.getters.fullname !== undefined && this.$store.getters.fullname !== null){
      if(this.$store.getters.fullname.id !== undefined && this.$store.getters.fullname.id !== null && this.$store.getters.fullname.id !== ''){
        this.userID = this.$store.getters.fullname.id
      }
    }
  },
  created () {
    if(this.$route.params.reload) {
      window.location.reload();
    }
  },
  watch: {
    '$route': 'initData'
  },
  methods: {
    checkVisible(groupName, action) {
      return this.$myConstants.checkVisible(this.$store.getters.permission, groupName, action);
    },
    initData() {
      setTimeout(async () => {
        await this.settingsHardCode();
        if (this.checkVisible('users', 'list')) {
          await this.getUsers();
          await this.initParams();
        }
      }, 1000);
    },
    async getUsers() {
      var total = 0, count = 0;
      var organizationLogin = this.$myConstants.organizationUserLogin();
      if (organizationLogin && Object.keys(organizationLogin).length) {
        this.organizationID = organizationLogin.id;
        total = organizationLogin.number_of_accounts;
        var variables = {
          where_key: {
            organization_id: {_eq: organizationLogin.id},
            user: {
              status: {"_eq": 1},
              user_type: {"_gt": 1},
              is_enabled: {"_eq": true}
            }
          }
        }
        var data = await DataServices.getList('organization_account', {"variables": JSON.stringify(variables), "aggregate": " { aggregate { count } } "});
        var list = data[Object.keys(data)];
        if (list && Object.keys(list).length) {
          count = (list.aggregate.count != undefined && list.aggregate.count != null) ? list.aggregate.count : 0;
        }
      }
      var className = (count >= total) ? "class='error'" : '';
      this.textInfoAcccount = this.textInfoAcccount.replace('{0}', '<b ' + className + ' >' + count + '/' + total + ' tài khoản </b>');
      this.showTextInfo = true;
    },
    async initParams() {
      var organization = this.$myConstants.organizationUserLogin();
      var creator_organization_id = (!this.$myConstants.isEmpty(organization.id)) ? organization.id:null;
      var id_organization_hong_ky =await this.$coreService.id_organization_hong_ky();
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      if(this.$route.params != undefined && this.$route.params != null && this.$route.params.organization_name != undefined && this.$route.params.organization_name != '') {
        this.filters['organization'] = this.$route.params.organization_name;
      }
      this.modelName = 'users';
      var whereKey = {
        status: {'_in': [1] },
        user_type: {'_gt': 1},
        // is_enabled: {'_eq': true},
        //id: {"_neq": this.$store.getters.fullname.id},
        full_name: {'_neq': ''}
      }
      //Phân quyền dữ liệu
      var is_management_units = false;
      if (parseFloat(id_organization_hong_ky) ==  creator_organization_id){
        if (!this.$myConstants.isEmpty(this.$store.getters.fullname.is_management_units)){
          if (this.$store.getters.fullname.is_management_units == true){
            is_management_units = true;
          }
        }
      }

      //if (!this.checkCompany()) {
        if (is_management_units == false){
        // if (!this.$myConstants.managementLevel()) {
        //    whereKey = Object.assign(whereKey,  {
        //     creator_id: {'_eq': this.$store.getters.fullname.id } 
        //   });
        // } 
        // else {
        whereKey = Object.assign(whereKey,  
          { "_and": {
              "_or": [
                {
                  organization_account: {
                    organization: {
                      status: {"_eq": 1},
                      id: {'_eq': this.organizationID}
                    }
                  }
                },
                {
                  organization_account: {
                    organization: {
                      parent_id: {"_eq": this.organizationID},
                      status: {"_eq": 1},
                      organization_type: {"_eq": "affiliate"}
                    }
                  }
                },
                {
                  organization_account: {
                    organization: {
                      parent_id: {"_eq": this.organizationID},
                      status: {"_eq": 1},
                      organization_type: {"_eq": "b2b"}
                    },
                    user: {
                      is_representative: {"_eq": true}
                    }
                  }
                }
              ]
            }
          }
        );
        // }
      }

      var variables = {
        where_key: whereKey,
        orderBy: {
          id: 'desc'
        }
      }

      var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables), "distinct": "id"});
      var list = data[Object.keys(data)];
      //list = list.filter(a => a.id != this.$store.getters.fullname.id);
      this.dataModel = DataServices.getModel(this.modelName);
      this.dataModel.processData(list);
      this.listDataExport = list;
      this.listData = list;
      this.componentKey++;
      this.$store.commit('setLoading', false);
    },
    // lấy đơn vị hardcode root
    async settingsHardCode() {
      var whereKey = {
        key: {'_eq': 'ORGANIZATION_ROOT' }
      }
      var variables = {
        where_key: whereKey
      }
      var data = await DataServices.getList('settings', {"variables": JSON.stringify(variables), "fields": "value"});
      var list = data[Object.keys(data)];
      if (list !== undefined && list !== null && Object.keys(list).length) {
        this.hardcodeID = list[0].value;
      }
    },
    checkCompany() {
      var organization = this.$myConstants.organizationUserLogin();
      var checkLevel = this.$myConstants.managementLevel();
      var levelParent = this.$myConstants.levelParent();
      if (organization && Object.keys(organization).length) {
        this.organizationID = organization.id;
        if (this.hardcodeID > 0 && this.organizationID > 0 && this.organizationID == this.hardcodeID && checkLevel && levelParent == 0) return true;
      }
     
      return false;
    },
    onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      switch (action.name) {
        case 'add':
          if(this.checkVisible('users', 'add')) {
            this.$router.push({path: '/admin/users/function'});
          }
          break;
        case 'edit':
          if(this.checkVisible('users', 'edit')) {
            if (data && Object.keys(data).length) {
              this.$router.push({path: '/admin/users/function/' + data.data.id});
            }
          }
          break;
      }
    },
    getRowActions() {
      var actions = {}
      var that = this;
      actions.filter = { name: 'clear', icon: 'times-circle'};
      actions.rows = function (rowData) {
        var buttons = {}
        if(that.checkVisible('users', 'edit')) {
          buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `admin/users/edit`}
          if (that.dataModel.actions) {
            var modelaction = that.dataModel.actions(rowData)
            Object.assign(buttons, modelaction);
          }
        }
        return buttons
      }
      return actions
    },
    cancelFilter() {
      this.filters = {};
      // this.componentKey++;
      this.listDataExport = this.listData;
    },
    async  exportDataExcel(){
      var list_id_users = [];
      if (this.listDataExport.length < 1){
        this.$toast.add({
          severity: 'error',
          summary: 'Thông báo',
          detail: 'Không tồn tại dữ liệu xuất',
          life: 3000
        });
        return false;
      }
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      for (var i=0;i<this.listDataExport.length;i++){
        list_id_users.push(this.listDataExport[i].id);
      }
        try {
          var dataResponse = await this.$coreService.callApiPost('/export_excel/list_users',{list_id_users:list_id_users,user_id : this.userID},{})
          var key_s3 = dataResponse.data.data.key_s3;
          var dataResponseDownload = await this.$coreService.callApiDownloadPost('/export_excel/read_file_export',{key_s3:key_s3},{})
          var url = URL.createObjectURL(new Blob([dataResponseDownload.data], {
            type: 'application/vnd.ms-excel'
          }))
          const link = document.createElement('a')
          link.href = url;
          var file_excel = 'BC_DanhSachTaiKhoan_'+moment().tz("Asia/Bangkok").format('DDMMYYYY')+'_'+moment().tz("Asia/Bangkok").format('HHmmss')+'.xlsx';
          link.setAttribute('download', file_excel)
          document.body.appendChild(link)
          link.click()
          this.showConfirmDialog = true;
          this.creenConfirmDialog = 'export_success';

      } catch (err) {
          console.log("err:",err);
          this.showConfirmDialog = true;
          this.creenConfirmDialog = 'export_err';
        }
      this.$store.commit('setLoading', false);
    },
    dang_phat_trien(){
      alert('Đang phát triển');
    },
    redirect_ToHistory(){
      this.$router.push({path: '/admin/history-export'});
    },
    async filterData(payload){
      console.log("assssssssss:",this.filters)
      this.listDataExport = payload.filteredValue;
    },
  }
}
</script>
<style lang="scss">
.box-filters{ margin: 15px 0;
  .p-formgroup-inline { display: flex;flex-wrap: wrap; align-items: flex-start;
    .p-field{ margin-right: 50px; margin-bottom: 15px;
      &:last-child{margin: 0; position: relative;}
      label{display: block;}
      .p-dropdown, input{width: 230px;}
      .btn-cancel{width: 90px;position: absolute; top: 30px;}
    }
  }
}
.external-link{ color: #0066FF; cursor: pointer;
  &.black-color {
    span{color: #000;}
  }
  span{color: #199ED8;}
}
.box-info-account { margin-bottom: 10px;}
.list_warranty_repair{
  .late_delivery_return_appointment_day{
    color: #CC0000;
  }
}

.import-data .download-file {
  color: #fff;
  border-width: 0px;
  min-width: 165px;
  height: 35px;
  background: #169bd5;
  border: none;
  border-radius: 5px;
  padding: 5px 20px;
}
.download-data{ position: relative; display: flex;
  span{margin-top: 14px; margin-left: 10px;}
}

.dialog-comfirm-common{
  width: 434px;
  .p-dialog-header{
    padding-bottom: 4px; padding-top: 4px;
  }
  .box_body_popup{
    width: 100%;
    .p_title_1{
      text-align: center;margin-bottom: 0px;
    }
    .p_title_2{
      text-align: center;
    }
    .box_btn{
      text-align: center;
      margin-top: 8px;
    }
    .box_title_suceess{
      margin-bottom: 10px;
      .img_noti{
        width: 20px;
        height: 20px;
      }
      .title_noti{
        font-family: 'Arial Bold', 'Arial'; font-weight: 700; font-style: normal; font-size: 18px; color: #009900;margin-left: 8px
      }
    }
    .box_title_err{
      margin-bottom: 10px;
      .img_noti{
        width: 20px;
        height: 20px;
      }
      .title_noti{
        font-family: 'Arial Bold', 'Arial'; font-weight: 700; font-style: normal; font-size: 18px; color: #FF0000;margin-left: 8px
      }
    }
  }
}
</style>